import React from 'react'
import Navigation from '../components/common/Navigation'
import PrivacyPolicy from '../components/legal/PrivacyPolicy'
import Wave from '../components/common/Wave'
import Social from '../components/common/Social'
import Copyright from '../components/common/Copyright'

function PrivacyPage() {
  return (
    <>
      <Navigation page="privacy"/>
      <PrivacyPolicy />
      <Wave />
      <div className="footer">
        <Social />
        <Copyright />     
      </div>
    </>
  )
}

export default PrivacyPage

